import { formatMoney } from "../../functions/money";
import React, { useEffect, useMemo, useState } from "react";
import { getProductInfo } from "../../api/shop";
import { useNavigate } from "react-router-dom";
import { ProductImage } from "../../components/productImage";
import {useCartAmounts} from "../../hooks/useCartAmounts";
import { useParams } from "react-router-dom";
//Redux
import { useDispatch, useSelector } from "react-redux";
//Components
//import { Button } from "@delibrandev/utils";
import { LuTrash2 } from "react-icons/lu";
import { removeProductCart } from "../../reducers/userConfigSlice";
import { CartActions } from "../../components/cartActions";
import "./style.css";
import { CartResume } from "../../components/cartResume";

export const CartContent = ({ canMakeOrder = true, drawer = false, quote }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.aplicationConfig.userConfig.cart);
  const paramsUrl = useParams();
  console.log("CART > ", cart, paramsUrl);

  const {amounts} = quote;
  const [selectionDetails, setSelectionDetails] = useState({});
  const products = useMemo(() => cart?.ShoppingCartProducts || [], [cart?.ShoppingCartProducts]);
  useEffect(() => {
    let active = true;
    const missing = products.filter(line => line.variantId && !line.Product?.variants?.length && !selectionDetails[line.productId]);
    const ids = [...new Set(missing.map(line => line.productId))];
    if (ids.length) Promise.all(ids.map(async id => {
      try {
        const response = await getProductInfo(id);
        const product = Array.isArray(response?.data) ? response.data[0] : response?.data;
        return [id, response?.error === false && product ? product : {}];
      } catch { return [id, {}]; }
    })).then(entries => { if (active) setSelectionDetails(previous => ({ ...previous, ...Object.fromEntries(entries) })); });
    return () => { active = false; };
  }, [products, selectionDetails]);
  const lineKey = line => JSON.stringify([line.productId,line.variantId || "",[...(line.itemIds || [])].sort(),line.note || ""]);
  const calculatePrice = data => {
    const line = amounts?.lines?.find(line => lineKey(line) === lineKey(data));
    if (drawer) return formatMoney(line?.lineTotalWithTax);
    return Number.isFinite(line?.lineNetTotal) ? line.lineNetTotal.toFixed(2) : "—";
  };

  const Product = ({ data }) => {
    const getVariantName = (id) => {
      const variant = (data?.Product?.variants?.length ? data.Product.variants : selectionDetails[data.productId]?.variants)?.filter((v) => v.variantId === id);
      if (variant && variant.length > 0) {
        const allOptions = variant[0].options;

        if (!Array.isArray(allOptions)) return [];
        return allOptions.map((opt) => opt.name);
      }
      return [];
    };

    const getItemsName = (ids) => {
      if (!Array.isArray(ids)) return [];

      if (Array.isArray(data.items)) return data.items.filter(Boolean).map(item => item.name);
      const groups = data?.Product?.itemGroups;
      if (!Array.isArray(groups)) return [];

      // Aplanamos todos los items de todos los grupos
      const allItems = groups.flatMap((group) => group.items ?? []);

      // Filtramos por itemId incluido en ids
      const matched = allItems?.filter((item) => ids.includes(item.itemId));

      // Devolvemos solo los nombres
      return matched ? matched.map((item) => item.name) : [];
    };
    return (
      <>
        <div className="product-cart" data-cart-line-key={lineKey(data)} style={data.unavailable?{filter:"grayscale(1)",opacity:0.6}:undefined}>
          <ProductImage src={data?.Product?.images?.[0]} name={data?.Product?.name || data?.name || "Producto"} />
          <div className="product-cart-info">
            <div className="product-details">
              {drawer ? <div className="eats-line-heading"><div className="product-name">{data?.Product?.name ?? data?.name}</div><button type="button" className="eats-line-remove" aria-label={`Eliminar ${data?.Product?.name ?? data?.name} del pedido`} onClick={() => dispatch(removeProductCart({ ...data, cartLineId: data.Product ? data.id : null, removeAll: true }))}><LuTrash2 aria-hidden="true" /></button></div> : <div className="product-name">{data?.Product?.name ?? data?.name}</div>}
              <div className="product-description">{data?.Product?.description}</div>
              <div className="flex-start" style={{ gap: "3px", fontSize: "0.7rem" }}>
                {[...getItemsName(data?.itemIds), getVariantName(data?.variantId).join(" · ")]?.join(" · ")}
                {/*getItemsName(data?.itemIds).map((item) => (
                  <div key={item} className="productCartItem">
                    {item}
                  </div>
                ))*/}
              </div>
              {data.note && <div className="product-note">{data.note}</div>}
              {/*<div className="flex-start" style={{ gap: "3px", marginTop: "1px", fontSize: "0.7rem" }}>
                getVariantName(data?.variantId)?.join(" · ")
              </div>*/}
            </div>
            <div className="product-details-bottom">
              <div className="product-name">{drawer ? calculatePrice(data) : `Base sin IVA: ${calculatePrice(data)}€`}</div>
              <div className="product-actions">
                {data.unavailable && <span role="status">Producto no disponible. Retíralo para continuar.</span>}
                <CartActions data={data} showAdd={!data.unavailable} />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  if (drawer) return <div className="eats-drawer-lines">{products.map((item, idx) => <Product key={item.key || item.id || idx} data={item} />)}</div>;

  return (
    <>
      <div className="cartContainer mainContainer" style={{ height: "calc(100vh - 280px)" }}>
        <div className="productList">
          <div>
            <h2>Tu pedido</h2>
            <button type="button" className="eats-back" onClick={() => navigate("/")}>← Seguir eligiendo</button>
          </div>
          {products.length > 0 ? (
            products.map((item, idx) => <Product key={item.key || item.id || idx} data={item} />)
          ) : (
            <div className="product-cart" style={{ border: "0" }}>
              No hay productos, agrega uno.
            </div>
          )}
        </div>
        {/*<div className="mobileRender orderMobile" style={{ flex: "0 0 213px" }}>
        <CartResume
          canMakeOrder={canMakeOrder}
          actionText={"Hacer pedido"}
          actionUrl={"/checkout"}
          actionBackText={"Volver"}
          actionBackUrl={"/products"}
        />
      </div>*/}
        <div className="desktopRender">
          <CartResume
            canMakeOrder={canMakeOrder}
            actionText={"Hacer pedido"}
            actionUrl={"/checkout"}
            /*actionBackText={"Volver"}
          actionBackUrl={"/products"}*/
          />
        </div>
      </div>
      <div className="mobileRender blockActionBottom">
        <CartResume
          canMakeOrder={canMakeOrder}
          actionText={"Hacer pedido"}
          actionUrl={"/checkout"}
          actionBackText={"Volver"}
          actionBackUrl={"/products"}
        />
      </div>
    </>
  );
};

export const Cart = props => {
  const quote = useCartAmounts();
  return <CartContent {...props} quote={quote} />;
};
